import { API_URL } from 'consts/common.const';
import { Http } from 'services/http';

export const getGeneral = () => {
  return Http.request<any[]>({
    method: 'GET',
    url: `${API_URL}/masterdata/get/common_setting`,
  });
};
